export default "__VITE_ASSET__CEOjCh_T__"